import React, { memo } from 'react';

interface AtrapaRitmoBackdropProps {
  beatPhase: number;
  pulse?: number;
}

export const AtrapaRitmoBackdrop = memo(function AtrapaRitmoBackdrop({
  beatPhase,
  pulse = 0,
}: AtrapaRitmoBackdropProps) {
  const beatScale = 1 + beatPhase * 0.04;

  return (
    <div className="ar-backdrop pointer-events-none absolute inset-0 overflow-hidden" aria-hidden>
      <div className="ar-backdrop-gradient" />

      <div
        className="ar-backdrop-beat-ring"
        style={{ transform: `translate(-50%, -50%) scale(${beatScale})` }}
      />

      {pulse > 0 && <div key={pulse} className="ar-backdrop-hit-wave" />}
    </div>
  );
});

export default AtrapaRitmoBackdrop;
